<template>
    <div class="grid">
        <div class="unit whole">
            <h1>Usage</h1>
            <p class="lead">View overall usage for your school's pupils.</p>
        </div>
    </div>
    <ReportingUsageComp
        :pupils="pupils"
        :classes="classes"
        roleView="admin"
        :isLoading="!(isLoaded.pupils || isLoaded.classes)"
    />
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';

definePage({ meta: { area: 'reporting' } });

const adminStore = useAdminStore();

adminStore.fetchClasses();
adminStore.fetchPupils();

const { pupils, classes, isLoaded } = storeToRefs(adminStore);
</script>
